export enum ButtonId {
    GROUP_DETAIL = "GROUP_DETAIL",
    ADD_GROUP = "ADD_GROUP",
    ADD_MEMBER = "ADD_MEMBER",
    DELETE_GROUP = "DELETE_GROUP",
    DELETE_PERMISSION = "DELETE_PERMISSION",
    REMOVE_MEMBER = "REMOVE_MEMBER",
}
